import { render, staticRenderFns } from "./ClubView.vue?vue&type=template&id=1d0ada7c"
import script from "./ClubView.vue?vue&type=script&lang=js"
export * from "./ClubView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports